import React, { type JSX } from "react";
import { MenuButton, Select } from "@narmi/design_system";
import catcat from "../utils/catcat";
interface LangSelectProps {
  localeCodes: string[];
  localeNames: string[];
  onChange: (event: any) => void;
  selectedLocale: string;
  transparentBackground?: boolean;
  useMobileMenu?: boolean;
}

const noop = () => {};

/**
 * **Fully controlled** Language selection component.
 *
 * These props should be taken from the result of the `useFluentLocalization` hook.
 * Size constraints should be managed by a parent wrapper.
 */
const LangSelect = ({
  localeCodes,
  localeNames,
  onChange = noop,
  selectedLocale = "en",
  transparentBackground = false,
  useMobileMenu = false,
}: LangSelectProps): JSX.Element => {
  const options = localeCodes.map((code, index) => ({
    value: code,
    label: useMobileMenu ? code.toUpperCase() : localeNames[index],
  }));
  const selectedOption = options.find((opt) => opt.value === selectedLocale) || options[0];

  if (transparentBackground) {
    return (
      <MenuButton
        showDropdownIndicator
        alignment="end"
        renderTrigger={(isOpen: boolean) => (
          <span className="language-selector-trigger">
            {useMobileMenu && (
              <span className="narmi-icon-globe language-selector-chevron margin--right--xxs" />
            )}
            {selectedOption.label}
            {!useMobileMenu && (
              <span
                className={catcat([
                  `narmi-icon-chevron-${isOpen ? "up" : "down"}`,
                  "language-selector-chevron",
                ])}
              />
            )}
          </span>
        )}
      >
        {options.map((opt) => (
          <MenuButton.Item
            key={opt.value}
            label={opt.label}
            onSelect={() => onChange(opt.value)}
            endIcon={opt.value === selectedLocale ? "check" : undefined}
          />
        ))}
      </MenuButton>
    );
  }
  return (
    <Select label="Language" onChange={onChange} value={selectedLocale}>
      {localeCodes.map((localeCode, i) => (
        <Select.Item key={localeCode} value={localeCode}>
          {localeNames[i]}
        </Select.Item>
      ))}
    </Select>
  );
};
export default LangSelect;
